/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListWorkloadIdentitiesSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type ListWorkloadIdentitiesSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListWorkloadIdentitiesSecurity = {
  option1?: ListWorkloadIdentitiesSecurityOption1 | undefined;
  option2?: ListWorkloadIdentitiesSecurityOption2 | undefined;
};

export type ListWorkloadIdentitiesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListWorkloadIdentitiesSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListWorkloadIdentitiesSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListWorkloadIdentitiesSecurityOption1$Outbound,
    ListWorkloadIdentitiesSecurityOption1
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listWorkloadIdentitiesSecurityOption1ToJSON(
  listWorkloadIdentitiesSecurityOption1: ListWorkloadIdentitiesSecurityOption1,
): string {
  return JSON.stringify(
    ListWorkloadIdentitiesSecurityOption1$outboundSchema.parse(
      listWorkloadIdentitiesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListWorkloadIdentitiesSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListWorkloadIdentitiesSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListWorkloadIdentitiesSecurityOption2$Outbound,
    ListWorkloadIdentitiesSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listWorkloadIdentitiesSecurityOption2ToJSON(
  listWorkloadIdentitiesSecurityOption2: ListWorkloadIdentitiesSecurityOption2,
): string {
  return JSON.stringify(
    ListWorkloadIdentitiesSecurityOption2$outboundSchema.parse(
      listWorkloadIdentitiesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListWorkloadIdentitiesSecurity$Outbound = {
  Option1?: ListWorkloadIdentitiesSecurityOption1$Outbound | undefined;
  Option2?: ListWorkloadIdentitiesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListWorkloadIdentitiesSecurity$outboundSchema: z.ZodMiniType<
  ListWorkloadIdentitiesSecurity$Outbound,
  ListWorkloadIdentitiesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListWorkloadIdentitiesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListWorkloadIdentitiesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listWorkloadIdentitiesSecurityToJSON(
  listWorkloadIdentitiesSecurity: ListWorkloadIdentitiesSecurity,
): string {
  return JSON.stringify(
    ListWorkloadIdentitiesSecurity$outboundSchema.parse(
      listWorkloadIdentitiesSecurity,
    ),
  );
}

/** @internal */
export type ListWorkloadIdentitiesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListWorkloadIdentitiesRequest$outboundSchema: z.ZodMiniType<
  ListWorkloadIdentitiesRequest$Outbound,
  ListWorkloadIdentitiesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listWorkloadIdentitiesRequestToJSON(
  listWorkloadIdentitiesRequest: ListWorkloadIdentitiesRequest,
): string {
  return JSON.stringify(
    ListWorkloadIdentitiesRequest$outboundSchema.parse(
      listWorkloadIdentitiesRequest,
    ),
  );
}
